import { SearchOutlined } from '@ant-design/icons'
import { Typography, Input, Table } from 'antd'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { StoreState } from 'src/store/configureStore'
import t from 'src/utils/translate'
import { useMemberName } from 'src/utils/useMemberName'
import { valueFilter, AvatarComponent } from '../DashboardUpdated/Dashboard'
import Highlighter from 'react-highlight-words'

const WorkorderTable = ({ tableDataSource, params }: any) => {
  const [filterTerm, setFilterTerm] = useState(params?.work_order_name || '')

  const [filters, setFilters] = useState<{
    created_by?: string[]
    work_order_stage?: string[]
    project_id?: string[]
  }>({})

  useEffect(() => {
    setFilters((prevState) => {
      return {
        ...prevState,
        created_by: params?.created_by ? params?.created_by : [],
        work_order_stage: params?.work_order_stage ? params?.work_order_stage : [],
        project_id: params?.project_id ? params?.project_id : []
      }
    })
  }, [params])

  const { getName } = useMemberName()

  useEffect(() => {
    setFilterTerm(params?.work_order_name || '')
  }, [params?.work_order_name])

  const { projectList } = useSelector((state: StoreState) => state.projects)

  const stagesMap = useSelector((state: StoreState) => state.displayNames.data?.stages)

  const tableColumns = [
    {
      title: t('workOrder.workOrderName'),
      dataIndex: 'work_order_name',
      key: 'work_order_name',
      width: 150,
      render: (value: string, record: any) => (
        <Link to={`/work-orders/details/${record.work_order_id}`}>
          <Typography.Text
            style={{
              margin: 0,
              width: 150
            }}
            ellipsis={{ tooltip: value }}
            strong
            className="dashboard_underline_text"
          >
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[filterTerm]}
              autoEscape
              textToHighlight={value ? `${value[0].toUpperCase()}${value.slice(1)}` : ''}
            />
          </Typography.Text>
        </Link>
      ),
      fixed: 'left' as 'left'
    },
    {
      title: t('common.stage'),
      dataIndex: 'work_order_stage',
      key: 'work_order_stage',
      width: 150,
      render: (value: any) => {
        return stagesMap[value] || value
      },
      filters: Array.from(new Set(tableDataSource.map((item: any) => item.work_order_stage))).map((item: any) => ({
        text: stagesMap[item] || item,
        value: item
      })),
      onFilter: (value: any, record: any) => {
        return valueFilter(value, record.work_order_stage)
      },
      filteredValue: filters?.work_order_stage || null
    },
    {
      dataIndex: 'created_by',
      title: t('common.createdBy'),
      key: 'created_by',
      align: 'center' as 'center',
      filters: Array.from(new Set(tableDataSource.map((item: any) => item.created_by))).map((item: any) => ({ text: getName(item), value: item })),
      onFilter: (value: any, record: any) => {
        return valueFilter(value, record.created_by)
      },
      filteredValue: filters?.created_by || null,
      filterSearch: true,
      width: 150,
      render: (member: any) => <AvatarComponent id={member} />
    },
    {
      title: t('common.project'),
      dataIndex: 'project_id',
      key: 'project_id',
      width: 150,
      render: (value: any) => {
        const project = projectList.find((item: any) => item.project_id === value)
        return project ? project.name : value
      },
      filters: Array.from(new Set(tableDataSource.filter((item: any) => !!item.project_id).map((item: any) => item.project_id))).map((item: any) => ({
        text: projectList.find((project: any) => project.project_id === item)?.name,
        value: item
      })),
      onFilter: (value: any, record: any) => {
        return valueFilter(value, record.project_id)
      },
      filteredValue: filters?.project_id || null
    }
  ]

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8
      }}
    >
      <Input
        prefix={<SearchOutlined />}
        onChange={(e) => setFilterTerm(e.target.value)}
        allowClear
        value={filterTerm}
        placeholder={t('workOrders.placeholder.searchWorkOrder')}
      />

      <Table
        columns={tableColumns}
        onChange={(pagination, filters, sorter, extra) => {
          setFilters(filters)
        }}
        dataSource={tableDataSource.filter((item: any) => {
          return item.work_order_name.toLowerCase().includes(filterTerm.toLowerCase())
        })}
        className="dashboard-activity-workorders-drawer-table"
        pagination={{
          style: { gap: 8 },
          pageSize: 5,
          size: 'small',
          showSizeChanger: false,
          hideOnSinglePage: true,
          showLessItems: true
        }}
        style={{
          width: '100%',
          scrollbarWidth: 'none'
        }}
      />
    </div>
  )
}

export default WorkorderTable
